import { render, staticRenderFns } from "./CaseEditor.vue?vue&type=template&id=4cadc398&"
import script from "./CaseEditor.vue?vue&type=script&lang=js&"
export * from "./CaseEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports